// src/components/DynamicIcon.jsx
import React from "react";
import icons from "./DashboardIcons";

const DynamicIcon = ({ iconName }) => {
    const IconComponent = icons[iconName]; // Get the icon dynamically

    if (!IconComponent) {
        return <p className="text-red-500">!</p>;
    }

    return <IconComponent />;
};

export default DynamicIcon;